import { judgeAcmg } from '@/@core/layouts/utils'
import { chromosomeRegion, formatDate } from '@/@core/utils/utils'
import { judgeStrength } from '@/views/analyze/ACMG'
import { ACMG_evidences_zh } from '../CurrentRepoet'

export const getTemplate11And13 = (
  report: any,
  reportsVariants: any[],
  samples: any[],
  userAcmgData: any[],
  affected_child_clinicalInformation: any,
  chromosomeData: any[],
  thalassemia: any,
  i18n: any,
  t: any
) => {
  if (samples.length === 0) {
    return []
  }
  return [
    {
      type:
        report.templatePath === '11' ? 'block-cq-title' : 'block-ajtk-title',
      children: [
        {
          type: 'span',
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-genetic',
      children: [
        {
          text: '全外显子组测序检测报告(Trio)'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '医院信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `送检医院` }]
                }
              ]
            },
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `送检医生` }]
                }
              ]
            },
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `门诊号/住院号` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        report?.templatePath === '11'
                          ? '重庆医科大学附属第二医院'
                          : '-'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '-' }]
                }
              ]
            },
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '-' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '样本信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `到样日期` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `样本编号` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `样本类型` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `姓名 ` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `关系` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `性别` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `民族` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `出生日期` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `年龄` }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      { text: formatDate(row.sample?.createdAt) ?? '-' }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.sample?.name ?? '-' }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.patient?.sampleType ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: row.patient?.patientName ?? '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.sample?.type ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.patient?.gender ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: t(row.patient?.ethnicity ?? '-') }]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: row.patient?.dateOfBirth
                          ? formatDate(row.patient?.dateOfBirth)
                          : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${
                          row.patient?.dateOfBirth
                            ? (Math.floor(
                                (new Date().valueOf() -
                                  new Date(
                                    row.patient?.dateOfBirth
                                  ).valueOf()) /
                                  3.15576e10
                              ) <= 0
                                ? 0
                                : Math.floor(
                                    (new Date().valueOf() -
                                      new Date(
                                        row.patient?.dateOfBirth
                                      ).valueOf()) /
                                      3.15576e10
                                  )) + '岁'
                            : '-'
                        }`
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }),
        ...samples.map((row, index) => {
          return {
            type: 'table-row',
            children: [
              index === 0
                ? {
                    type: `table-cell-r${samples.length}`,
                    children: [
                      {
                        type: 'p3-center',
                        children: [{ text: '临床表现和家族史' }]
                      }
                    ]
                  }
                : {
                    type: 'display-none',
                    children: [
                      {
                        type: 'p3-center',
                        children: [{ text: '' }]
                      }
                    ]
                  },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.sample?.name ?? '-' }]
                  }
                ]
              },
              {
                type: 'table-cell-c7',
                children: [
                  {
                    type: 'p3-center',
                    children: [{ text: row.sample?.clinicalInformation }]
                  }
                ]
              }
            ]
          }
        }),
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `表型匹配标准术语` }]
                }
              ]
            },
            {
              type: 'table-cell-c8',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `-` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `临床怀疑疾病` }]
                },
                {
                  type: 'p3-center',
                  children: [{ text: `/重点分析基因集` }]
                }
              ]
            },
            {
              type: 'table-cell-c8',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: ''
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测项目` }]
                }
              ]
            },
            {
              type: 'table-cell-c4',
              children: [
                {
                  type: 'p7',
                  children: [{ text: `临床全外显子组检测-家系（VIP）` }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测编号` }]
                }
              ]
            },
            {
              type: 'table-cell-c3',
              children: [
                {
                  type: 'p7',
                  children: [{ text: `DX1680` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测区域` }]
                }
              ]
            },
            {
              type: 'table-cell-c8',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `人类基因组中约 2 万个基因的外显子区+线粒体基因组`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测策略` }]
                }
              ]
            },
            {
              type: 'table-cell-c8',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `针对受检者主诉，对 OMIM 数据库收录的明确致病关系基因进行分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: `检测方法` }]
                }
              ]
            },
            {
              type: 'table-cell-c8',
              children: [
                {
                  type: 'p7',
                  children: [{ text: `芯片捕获高通量测序` }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测结论'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p7-HighlightText',
                  children: [
                    {
                      text: reportsVariants
                        .filter((item) => item.variantsType === 'KeyFinding')
                        .filter((row) => row.chrom !== 'MT')
                        .filter((row) => row.pos)
                        .filter((row) => row.variant_type !== 'CNV')
                        .filter(
                          (row) =>
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'likely pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'likely pathogenic'
                        ).length
                        ? `<span style="color: red;">1. 主要检测结果为：发现与受检者临床表型高度相关的${reportsVariants
                            .filter(
                              (item) => item.variantsType === 'KeyFinding'
                            )
                            .filter((row) => row.pos)
                            .filter((row) => row.variant_type !== 'CNV')
                            .filter((row) => row.chrom !== 'MT')
                            .map((i) => i.gene)
                            .join(';')}基因变异；</span>`
                        : `1. 主要检测结果为：：未检出与受检者临床表型相关的致病/疑似致病变异/遗传模式相符的临床意义未明变异。`
                    }
                  ]
                },
                {
                  type: 'p7-HighlightText',
                  children: [
                    {
                      text: reportsVariants
                        .filter(
                          (item) => item.variantsType === 'IncidentalDiscovery'
                        )
                        .filter((row) => row.pos)
                        .filter((row) => row.variant_type !== 'CNV')
                        .filter((row) => row.chrom !== 'MT')
                        .filter(
                          (row) =>
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'likely pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'likely pathogenic'
                        ).length
                        ? `<span style="color: red;">2. 次要检测结果为：发现与受检者临床表型部分相关的${reportsVariants
                            .filter(
                              (item) =>
                                item.variantsType === 'IncidentalDiscovery'
                            )
                            .filter((row) => row.pos)
                            .filter((row) => row.variant_type !== 'CNV')
                            .filter((row) => row.chrom !== 'MT')
                            .map((i) => i.gene)
                            .join(';')}基因变异；</span>`
                        : `2. 次要检测结果为：未检出与受检者临床表型相关的致病/疑似致病变异/遗传模式相符的临床意义未明变异。`
                    }
                  ]
                },
                {
                  type: 'p7-HighlightText',
                  children: [
                    {
                      text: reportsVariants
                        .filter((row) => row.pos)
                        .filter((row) => row.variant_type !== 'CNV')
                        .filter((row) => row.chrom === 'MT')
                        .filter(
                          (row) =>
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'likely pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'likely pathogenic'
                        ).length
                        ? `<span style="color: red;">3. 线粒体基因检测结果为：发现与受检者临床表型不相关线粒体${reportsVariants
                            .filter((row) => row.pos)
                            .filter((row) => row.variant_type !== 'CNV')
                            .filter((row) => row.chrom === 'MT')
                            .map((i) => `MT-${i.gene}`)
                            .join(
                              ';'
                            )}基因变异，由于与受检者表型不符，未能确定该变异与受检者临床症状是否有关系，因此出具补充报告基因变异，Sanger测序验证结果见附录；详见 页</span>`
                        : `3. 线粒体基因检测结果为：未检出与临床表型相关的线粒体基因变异。`
                    }
                  ]
                },
                {
                  type: 'p7-HighlightText',
                  children: [
                    {
                      text: reportsVariants
                        .filter(
                          (item) =>
                            item.variantsType === 'CarrierScreening' ||
                            item.variantsType === 'ACMGDiscovery'
                        )
                        .filter((row) => row.pos)
                        .filter((row) => row.variant_type !== 'CNV')
                        .filter((row) => row.chrom !== 'MT')
                        .filter(
                          (row) =>
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.ACMG_classification.toLocaleLowerCase() ===
                              'likely pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.user_acmg_classification.toLocaleLowerCase() ===
                              'likely pathogenic'
                        ).length
                        ? `<span style="color: red;">4. 意外发现检测结果为：发现与受检者表型不相关的${reportsVariants
                            .filter(
                              (item) =>
                                item.variantsType === 'CarrierScreening' ||
                                item.variantsType === 'ACMGDiscovery'
                            )
                            .filter((row) => row.pos)
                            .filter((row) => row.variant_type !== 'CNV')
                            .filter((row) => row.chrom !== 'MT')
                            .map((i) => i.gene)
                            .join(';')}基因变异；详见 页</span>`
                        : `4. 意外发现检测结果为：未检出意外发现的致病或疑似致病变异（SecondaryFinding_Var 数据库）。`
                    }
                  ]
                },
                {
                  type: 'p7-HighlightText',
                  children: [
                    {
                      text: reportsVariants.filter(
                        (row) => row.variant_type === 'CNV'
                      ).length
                        ? `<span style="color: red;">5. 染色体 CNV/其他补充报告检测结果为：发现与受检者临床表型可能相关的拷贝数变异，基于高通量全外的CNV检测不属于全外的常规检测范围，因此出具补充报告;详见 页</span>`
                        : `5. 染色体 CNV/其他补充报告检测结果为：本次检测，经高通量数据信息分析，未检出与先证者表型相关的 1M 以上致病染色体 CNV 变异和 5M 以上的 LOH变异。基于高通量全外的 CNV 和 LOH 检测不属于全外的常规检测范围，如需更精准的染色体 CNV 和 LOH 结果，建议送检相关染色体检测。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '主要检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '序号'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '转录本编号'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '核苷酸变化'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '(氨基酸变化)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '分类 '
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 疾病及遗传方式'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .filter((row) => row.pos)
          .filter((row) => row.variant_type !== 'CNV')
          .filter((row) => row.chrom !== 'MT')
          .map((row, index) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${index + 1}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom}:${row.pos}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `(${row.p_nomen})`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    ...samples.map((item) => {
                      let allele_frequency = row.allele_frequency
                      const samples_info = row.samples_info ?? []

                      const temp = samples_info.find(
                        (i: any) => i.sample_id === item.sample.id
                      )

                      if (temp && temp.allele_frequency) {
                        allele_frequency = temp.allele_frequency
                      }

                      if (item.sample.type === 'mother') {
                        if (row.mom_allele_frequency) {
                          allele_frequency = row.mom_allele_frequency
                        }
                      } else if (item.sample.type === 'affected_child') {
                        allele_frequency = row.allele_frequency
                      } else if (item.sample.type === 'father') {
                        if (row.dad_allele_frequency) {
                          allele_frequency = row.dad_allele_frequency
                        }
                      }

                      console.log(
                        'allele_frequency',
                        item.sample.type,
                        allele_frequency
                      )

                      return {
                        type: 'p3-center',
                        children: [
                          {
                            text: `${
                              item.sample.type ? `${t(item.sample.type)}:` : ''
                            }${
                              allele_frequency && allele_frequency !== '.'
                                ? allele_frequency < 0.85
                                  ? t('heterozygote')
                                  : t('homozygote')
                                : '无'
                            }`
                          }
                        ]
                      }
                    })
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? judgeAcmg(row.user_acmg_classification)
                            : row.ACMG_classification
                            ? judgeAcmg(row.ACMG_classification)
                            : row.classification
                            ? judgeAcmg(row.classification)
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .filter((row) => row.pos)
          .filter((row) => row.variant_type !== 'CNV')
          .filter((row) => row.chrom !== 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**遗传模式：AD 表示常染色体显性遗传，AR 表示常染色体隐性遗传，XL 表示 X 染色体连锁遗传，YL 表示 Y 染色体连锁遗传，UNK 表示 Unknown 即遗传模式未知。'
                    }
                  ]
                },
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**主要检测结果包括：与临床表型相关的致病/疑似致病变异；与临床表型相关，且遗传模式相符的临床意义未明变异。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '结果说明：'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: reportsVariants
                        .filter((row) => row.chrom !== 'MT')
                        .filter((item) => item.variantsType === 'KeyFinding')
                        .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                        .length
                        ? `根据ACMG指南，${reportsVariants
                            .filter((row) => row.chrom !== 'MT')
                            .filter(
                              (item) => item.variantsType === 'KeyFinding'
                            )
                            .filter(
                              (row) => row.pos && row.c_nomen && row.p_nomen
                            )
                            .map(
                              (row) =>
                                `提示${row.gene}基因${
                                  row.c_nomen !== '.'
                                    ? `${row.c_nomen}(${row.p_nomen})`
                                    : ``
                                }的突变为${
                                  row.user_acmg_classification
                                    ? row.user_acmg_classification
                                    : row.ACMG_classification
                                    ? row.ACMG_classification
                                    : row.classification
                                    ? row.classification
                                    : ''
                                }`
                            )
                            .join('，')}`
                        : '未检出与临床表型相关的致病/疑似致病变异；与临床表型相关，且遗传模式相符的临床意义未明变异。'
                    }
                  ]
                },

                ...reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((item) => item.variantsType === 'KeyFinding')
                  .filter((row) => row.chrom !== 'MT')
                  .map((row, index) => {
                    const af_table =
                      row?.VariantsArticles?.population_data?.af_table ?? []
                    const totalAftable = af_table.find(
                      (i: any) => i.Population === 'Total'
                    )

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    log.variantKey ===
                                      `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText =
                                    i.clinicalSynopsis_zh
                                      ? `<span style="font-weight: 600;">临床表型：</span>${i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')}`
                                      : `<span style="font-weight: 600;">临床表现相关文献：</span>\n${
                                          i.phenoClinicalFeaturesCNStr
                                            ? i.phenoClinicalFeaturesCNStr.join(
                                                '\n'
                                              )
                                            : t('No Results')
                                        }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: `该变异人群频率如下：`
                            }
                          ]
                        },
                        {
                          type: 'table-available',
                          children: [
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `数据库` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD-EAS` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `1000g` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ExAC` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ALFA` }]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `频率值` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_ALL}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_EAS}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        {
                                          text: `${
                                            totalAftable
                                              ? totalAftable['1000g']
                                              : '.'
                                          }`
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ExAC ?? '.'}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ALFA ?? '.'}` }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '次要检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '序号'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '转录本编号'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '核苷酸变化'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '(氨基酸变化)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '分类 '
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 疾病及遗传方式'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'IncidentalDiscovery')
          .filter((row) => row.pos && row.c_nomen && row.p_nomen)
          .filter((row) => row.chrom !== 'MT')
          .map((row, index) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${index + 1}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom}:${row.pos}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `(${row.p_nomen})`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    ...samples.map((item) => {
                      let allele_frequency = row.allele_frequency as any
                      const samples_info = row.samples_info ?? []

                      const temp = samples_info.find(
                        (i: any) => i.sample_id === item.sample.id
                      )

                      if (temp && temp.allele_frequency) {
                        allele_frequency = temp.allele_frequency
                      }

                      if (item.sample.type === 'mother') {
                        if (row.mom_allele_frequency) {
                          allele_frequency = row.mom_allele_frequency
                        }
                      } else if (item.sample.type === 'affected_child') {
                        allele_frequency = row.allele_frequency
                      } else if (item.sample.type === 'father') {
                        if (row.dad_allele_frequency) {
                          allele_frequency = row.dad_allele_frequency
                        }
                      }

                      console.log(
                        'allele_frequency',
                        item.sample.type,
                        allele_frequency
                      )

                      return {
                        type: 'p3-center',
                        children: [
                          {
                            text: `${
                              item.sample.type ? `${t(item.sample.type)}:` : ''
                            }${
                              allele_frequency && allele_frequency !== '.'
                                ? allele_frequency < 0.85
                                  ? t('heterozygote')
                                  : t('homozygote')
                                : '无'
                            }`
                          }
                        ]
                      }
                    })
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? judgeAcmg(row.user_acmg_classification)
                            : row.ACMG_classification
                            ? judgeAcmg(row.ACMG_classification)
                            : row.classification
                            ? judgeAcmg(row.classification)
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter((item) => item.variantsType === 'IncidentalDiscovery')
          .filter((row) => row.pos && row.c_nomen && row.p_nomen)
          .filter((row) => row.chrom !== 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**次要检测结果包括：其他与临床表型相关的变异。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '结果说明：'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: reportsVariants
                        .filter((row) => row.chrom !== 'MT')
                        .filter(
                          (item) => item.variantsType === 'IncidentalDiscovery'
                        )
                        .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                        .length
                        ? `根据ACMG指南，${reportsVariants
                            .filter((row) => row.chrom !== 'MT')
                            .filter(
                              (item) =>
                                item.variantsType === 'IncidentalDiscovery'
                            )
                            .filter(
                              (row) => row.pos && row.c_nomen && row.p_nomen
                            )
                            .map(
                              (row) =>
                                `提示${row.gene}基因${
                                  row.c_nomen !== '.'
                                    ? `${row.c_nomen}(${row.p_nomen})`
                                    : ``
                                }的突变为${
                                  row.user_acmg_classification
                                    ? row.user_acmg_classification
                                    : row.ACMG_classification
                                    ? row.ACMG_classification
                                    : row.classification
                                    ? row.classification
                                    : ''
                                }`
                            )
                            .join('，')}`
                        : '未检出与临床表型相关的致病/疑似致病变异；与临床表型相关，且遗传模式相符的临床意义未明变异。'
                    }
                  ]
                },

                ...reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter((item) => item.variantsType === 'IncidentalDiscovery')
                  .filter((row) => row.chrom !== 'MT')
                  .map((row, index) => {
                    const af_table =
                      row?.VariantsArticles?.population_data?.af_table ?? []
                    const totalAftable = af_table.find(
                      (i: any) => i.Population === 'Total'
                    )

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    log.variantKey ===
                                      `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.clinicalSynopsis_zh
                                      ? i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')
                                      : i.phenoClinicalFeaturesCNStr
                                      ? i.phenoClinicalFeaturesCNStr.join('\n')
                                      : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: `该变异人群频率如下：`
                            }
                          ]
                        },
                        {
                          type: 'table-available',
                          children: [
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `数据库` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD-EAS` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `1000g` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ExAC` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ALFA` }]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `频率值` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_ALL}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_EAS}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        {
                                          text: `${
                                            totalAftable
                                              ? totalAftable['1000g']
                                              : '.'
                                          }`
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ExAC ?? '.'}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ALFA ?? '.'}` }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '线粒体基因检测结果'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '序号'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '转录本编号'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '核苷酸变化'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '(氨基酸变化)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '突变频率'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '(变异碱基:'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '总碱基reads 数)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '分类'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '相关疾病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'MtD 频率'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: 'MITOMAP'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '频率'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((row) => row.chrom === 'MT')
          .map((row, index) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${index + 1}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `(${row.p_nomen})`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    ...samples.map((item) => {
                      let allele_frequency = row.allele_frequency
                      const samples_info = row.samples_info ?? []

                      const fastQc = item.fastQc ?? {}
                      const metricsData = fastQc.metricsData ?? {}
                      const rawReads = metricsData.rawReads ?? '-'

                      const temp = samples_info.find(
                        (i: any) => i.sample_id === item.sample.id
                      )

                      if (temp && temp.allele_frequency) {
                        allele_frequency = temp.allele_frequency
                      }

                      if (item.sample.type === 'mother') {
                        if (row.mom_allele_frequency) {
                          allele_frequency = row.mom_allele_frequency
                        }
                      } else if (item.sample.type === 'affected_child') {
                        allele_frequency = row.allele_frequency
                      } else if (item.sample.type === 'father') {
                        if (row.dad_allele_frequency) {
                          allele_frequency = row.dad_allele_frequency
                        }
                      }

                      console.log(
                        'allele_frequency',
                        item.sample.type,
                        allele_frequency
                      )

                      return {
                        type: 'p3-center',
                        children: [
                          {
                            text: `${
                              item.sample.type ? `${t(item.sample.type)}:` : ''
                            }${
                              allele_frequency && allele_frequency !== '.'
                                ? allele_frequency
                                : '无'
                            }(${row.coverage})`
                          }
                        ]
                      }
                    })
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? judgeAcmg(row.user_acmg_classification)
                            : row.ACMG_classification
                            ? judgeAcmg(row.ACMG_classification)
                            : row.classification
                            ? judgeAcmg(row.classification)
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '无'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants.filter((row) => row.chrom === 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**线粒体检测结果包括：与临床表型相关的已报道明确致病变异,参考人类线粒体基因组数据库：https://www.mitomap.org'
                    }
                  ]
                },
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**线粒体基因组参考序列：NC_012920'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '结果说明：'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: reportsVariants.filter((row) => row.chrom === 'MT')
                        .length
                        ? `根据ACMG指南，${reportsVariants
                            .filter((row) => row.chrom === 'MT')
                            .map(
                              (row) =>
                                `提示${row.gene}基因${
                                  row.c_nomen !== '.'
                                    ? `${row.c_nomen}(${row.p_nomen})`
                                    : ``
                                }的突变为${
                                  row.user_acmg_classification
                                    ? row.user_acmg_classification
                                    : row.ACMG_classification
                                    ? row.ACMG_classification
                                    : row.classification
                                    ? row.classification
                                    : ''
                                }`
                            )
                            .join('，')}`
                        : '未检出与临床表型相关的致病/疑似致病变异；与临床表型相关，且遗传模式相符的临床意义未明变异。'
                    }
                  ]
                },

                ...reportsVariants
                  .filter((row) => row.chrom === 'MT')
                  .map((row, index) => {
                    const af_table =
                      row?.VariantsArticles?.population_data?.af_table ?? []
                    const totalAftable = af_table.find(
                      (i: any) => i.Population === 'Total'
                    )

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    log.variantKey ===
                                      `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.clinicalSynopsis_zh
                                      ? i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')
                                      : i.phenoClinicalFeaturesCNStr
                                      ? i.phenoClinicalFeaturesCNStr.join('\n')
                                      : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: `该变异人群频率如下：`
                            }
                          ]
                        },
                        {
                          type: 'table-available',
                          children: [
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `数据库` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD-EAS` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `1000g` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ExAC` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ALFA` }]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `频率值` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_ALL}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_EAS}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        {
                                          text: `${
                                            totalAftable
                                              ? totalAftable['1000g']
                                              : '.'
                                          }`
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ExAC ?? '.'}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ALFA ?? '.'}` }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        report.templatePath === '11'
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9-2',
                  children: [
                    {
                      type: 'header3-yunnan-krd2',
                      children: [
                        {
                          text: '地中海贫血热点检测结果'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        report.templatePath === '11'
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-color',
                  children: [{ text: 'Disease type' }]
                },
                {
                  type: 'table-cell-color',
                  children: [{ text: 'Mutant gene' }]
                },
                {
                  type: 'table-cell-color',
                  children: [{ text: 'Nucleotide changes' }]
                },
                {
                  type: 'table-cell-color',
                  children: [{ text: 'Chromosome position' }]
                },
                {
                  type: 'table-cell-color-c5',
                  children: [{ text: 'Result' }]
                }
              ]
            },
        report.templatePath === '11'
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: 'α thalassemia'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: 'HBA1'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: 'HBA2'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${
                            thalassemia &&
                            thalassemia.HBA1x &&
                            thalassemia.HBA1x.length &&
                            thalassemia.HBA1x[0].includes('//')
                              ? thalassemia.HBA1x[0].split('//')[0]
                              : '-'
                          }/${
                            thalassemia &&
                            thalassemia.HBA1y &&
                            thalassemia.HBA1y.length &&
                            thalassemia.HBA1y[0].includes('//')
                              ? thalassemia.HBA1y[0].split('//')[0]
                              : '-'
                          }`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${
                            thalassemia &&
                            thalassemia.HBA2x &&
                            thalassemia.HBA2x.length &&
                            thalassemia.HBA2x[0].includes('//')
                              ? thalassemia.HBA2x[0].split('//')[0]
                              : '-'
                          }/${
                            thalassemia &&
                            thalassemia.HBA2y &&
                            thalassemia.HBA2y.length &&
                            thalassemia.HBA2y[0].includes('//')
                              ? thalassemia.HBA2y[0].split('//')[0]
                              : '-'
                          }`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${
                            thalassemia &&
                            thalassemia.HBA1x &&
                            thalassemia.HBA1x.length &&
                            thalassemia.HBA1x[0].includes('//')
                              ? thalassemia.HBA1x[0].split('//')[1]
                              : '-'
                          }/${
                            thalassemia &&
                            thalassemia.HBA1y &&
                            thalassemia.HBA1y.length &&
                            thalassemia.HBA1y[0].includes('//')
                              ? thalassemia.HBA1y[0].split('//')[1]
                              : '-'
                          }`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${
                            thalassemia &&
                            thalassemia.HBA2x &&
                            thalassemia.HBA2x.length &&
                            thalassemia.HBA2x[0].includes('//')
                              ? thalassemia.HBA2x[0].split('//')[1]
                              : '-'
                          }/${
                            thalassemia &&
                            thalassemia.HBA2y &&
                            thalassemia.HBA2y.length &&
                            thalassemia.HBA2y[0].includes('//')
                              ? thalassemia.HBA2y[0].split('//')[1]
                              : '-'
                          }`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c5',
                  children: [
                    {
                      type: 'radio-group-α-thalassemia-eh',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        report.templatePath === '11'
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: 'β thalassemia'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: 'HBB'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c5',
                  children: [
                    {
                      type: 'radio-group-β-thalassemia-eh',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        report.templatePath === '11'
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c9-2',
                  children: [
                    {
                      type: 'paragraph-small',
                      children: [
                        {
                          text: '注:1.“-”表示在所筛查阳性位点范围内未发现受检者携带有该基因的致病位点。'
                        }
                      ]
                    },
                    {
                      type: 'paragraph-small',
                      children: [
                        {
                          text: '          2.--SEA、- -THA1、- -FIL等表示缺失2个a基因:-a 3.7、-a4.2 表示缺失 1个a基因。'
                        }
                      ]
                    },
                    {
                      type: 'paragraph-small',
                      children: [
                        {
                          text: '          3.更多关于地贫基因变化的信息请详看基因型与疾病状态'
                        }
                      ]
                    },
                    {
                      type: 'paragraph-small',
                      children: [
                        {
                          text: '          4.以上结论均为实验室检测数据，仅用于突变检测之目的，供临床参考，不代表临床最终诊断结果。'
                        }
                      ]
                    },
                    {
                      type: 'paragraph-small',
                      children: [
                        {
                          text: '          5.地中海贫血临床遗传咨询:静止型 G-地贫携带者、-标准型携带者个体(-地贫特征)和 B-地贫携带者，非患病个体，通常无临床贫血症状(血液学筛査可表现为小细胞低色素贫血特征)且终生稳定，对发育无影响，无需针对性治疗(无需临床处理)。另外，《珠蛋白基因重复(包括三联体和四联体甚至多联体)通常也无临床贫血症状;但其复合β地贫时，临床表现差异较大，从轻度贫血到重度贫血均有可能。其他类型(HbH病，HbBarts胎儿水肿综合征，B-地贫纯合或双重杂合突变携带者)为患病个体，有临床风险，需根据情况及时就医治疗。'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '意外发现'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '序号'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '染色体位置'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '转录本编号'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '核苷酸变化'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '(氨基酸变化)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '基因型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: '分类 '
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [
                    {
                      text: ' 疾病及遗传方式'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter(
            (item) =>
              item.variantsType === 'CarrierScreening' ||
              item.variantsType === 'ACMGDiscovery'
          )
          .filter((row) => row.pos)
          .filter((row) => row.variant_type !== 'CNV')
          .filter((row) => row.chrom !== 'MT')
          .map((row, index) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${index + 1}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.gene ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `chr${row.chrom}:${row.pos}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.transcript}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.c_nomen}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `(${row.p_nomen})`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: `${row.exon === '.' ? '' : `(${row.exon})`}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    ...samples.map((item) => {
                      let allele_frequency = row.allele_frequency
                      const samples_info = row.samples_info ?? []

                      const temp = samples_info.find(
                        (i: any) => i.sample_id === item.sample.id
                      )

                      if (temp && temp.allele_frequency) {
                        allele_frequency = temp.allele_frequency
                      }

                      if (item.sample.type === 'mother') {
                        if (row.mom_allele_frequency) {
                          allele_frequency = row.mom_allele_frequency
                        }
                      } else if (item.sample.type === 'affected_child') {
                        allele_frequency = row.allele_frequency
                      } else if (item.sample.type === 'father') {
                        if (row.dad_allele_frequency) {
                          allele_frequency = row.dad_allele_frequency
                        }
                      }

                      console.log(
                        'allele_frequency',
                        item.sample.type,
                        allele_frequency
                      )

                      return {
                        type: 'p3-center',
                        children: [
                          {
                            text: `${
                              item.sample.type ? `${t(item.sample.type)}:` : ''
                            }${
                              allele_frequency && allele_frequency !== '.'
                                ? allele_frequency < 0.85
                                  ? t('heterozygote')
                                  : t('homozygote')
                                : '无'
                            }`
                          }
                        ]
                      }
                    })
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? judgeAcmg(row.user_acmg_classification)
                            : row.ACMG_classification
                            ? judgeAcmg(row.ACMG_classification)
                            : row.classification
                            ? judgeAcmg(row.classification)
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          type: 'p3-center-max',
                          children: [
                            {
                              text: row.OMIMCN ? row.OMIMCN : ''
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        reportsVariants
          .filter(
            (item) =>
              item.variantsType === 'CarrierScreening' ||
              item.variantsType === 'ACMGDiscovery'
          )
          .filter((row) => row.pos)
          .filter((row) => row.variant_type !== 'CNV')
          .filter((row) => row.chrom !== 'MT').length
          ? {
              type: 'display-none',
              children: [
                {
                  text: ''
                }
              ]
            }
          : {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-c2',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          type: 'paragraph',
                          children: [
                            {
                              text: '-'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '**意外发现检测结果包括：受检者知情同意报告 SecondaryFinding_Var 数据库中的致病或疑似致病变异位点，此类变异关联疾病可能与患者目前临床表现及诊断无关。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p3',
                  children: [
                    {
                      text: '结果说明：'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: reportsVariants
                        .filter((row) => row.chrom !== 'MT')
                        .filter(
                          (item) =>
                            item.variantsType === 'CarrierScreening' ||
                            item.variantsType === 'ACMGDiscovery'
                        )
                        .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                        .length
                        ? `根据ACMG指南，${reportsVariants
                            .filter((row) => row.chrom !== 'MT')
                            .filter(
                              (item) =>
                                item.variantsType === 'CarrierScreening' ||
                                item.variantsType === 'ACMGDiscovery'
                            )
                            .filter(
                              (row) => row.pos && row.c_nomen && row.p_nomen
                            )
                            .map(
                              (row) =>
                                `提示${row.gene}基因${
                                  row.c_nomen !== '.'
                                    ? `${row.c_nomen}(${row.p_nomen})`
                                    : ``
                                }的突变为${
                                  row.user_acmg_classification
                                    ? row.user_acmg_classification
                                    : row.ACMG_classification
                                    ? row.ACMG_classification
                                    : row.classification
                                    ? row.classification
                                    : ''
                                }`
                            )
                            .join('，')}`
                        : '未检出与临床表型相关的致病/疑似致病变异；与临床表型相关，且遗传模式相符的临床意义未明变异。'
                    }
                  ]
                },

                ...reportsVariants
                  .filter((row) => row.pos && row.c_nomen && row.p_nomen)
                  .filter(
                    (item) =>
                      item.variantsType === 'CarrierScreening' ||
                      item.variantsType === 'ACMGDiscovery'
                  )
                  .filter((row) => row.chrom !== 'MT')
                  .map((row, index) => {
                    const af_table =
                      row?.VariantsArticles?.population_data?.af_table ?? []
                    const totalAftable = af_table.find(
                      (i: any) => i.Population === 'Total'
                    )

                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'p7',
                              children: [
                                {
                                  type: 'span-red',
                                  text: `${index + 1}）基因${row.gene}${
                                    row.chrom !== '.'
                                      ? `:${row.c_nomen}(${row.p_nomen})变异`
                                      : ''
                                  }：${judgeAcmg(
                                    row.user_acmg_classification
                                      ? row.user_acmg_classification
                                      : row.ACMG_classification
                                      ? row.ACMG_classification
                                      : row.classification
                                  )}${
                                    row.acmg_evidences
                                      ? `（${row.acmg_evidences?.join(',')}）`
                                      : ''
                                  }`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: row.acmg_evidences?.length
                            ? row.acmg_evidences?.map((item: any) => {
                                const first = item.split('_')[0]
                                let text = ACMG_evidences_zh[first]

                                const temp = userAcmgData.find(
                                  (log) =>
                                    log.variantKey ===
                                      `${row.gene}-${row.c_nomen}-${row.transcript}` &&
                                    `${first}${
                                      judgeStrength(item)
                                        ? `-${judgeStrength(item)}`
                                        : ''
                                    }` === log.acmgCriteria
                                )

                                if (first === 'PM2') {
                                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                                }

                                return {
                                  type: 'p7',
                                  children: [
                                    {
                                      text: `${item}:${
                                        temp ? temp?.evidenceDetails : text
                                      }`
                                    }
                                  ]
                                }
                              })
                            : [
                                {
                                  type: 'display-none',
                                  children: [
                                    {
                                      text: ``
                                    }
                                  ]
                                }
                              ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病临床描述`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `基因：${row.gene}`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              type: 'span-blod',
                              children: [
                                {
                                  text: `疾病:`
                                }
                              ]
                            }
                          ]
                        },
                        {
                          type: 'p5-genetic-value',
                          children:
                            row.OMIMData && row.OMIMData.length
                              ? row.OMIMData?.map((i: any, index: any) => {
                                  const higlitghtStr =
                                    affected_child_clinicalInformation
                                      ? affected_child_clinicalInformation
                                          .split('，')
                                          .join(',')
                                          .split(',')
                                          .join('|')
                                      : ''
                                  const regex = new RegExp(
                                    `(${higlitghtStr})`,
                                    'gi'
                                  )
                                  const phenoDescriptionCNText = `<span style="font-weight: 600;">疾病介绍：</span>${
                                    i.phenoDescriptionCNStr
                                      ? i.phenoDescriptionCNStr
                                          .join('\n')
                                          .replace(/\s+/g, '')
                                      : t('No Results')
                                  }`
                                  const phenoClinicalCNText = `<span style="font-weight: 600;">临床表型：</span>${
                                    i.clinicalSynopsis_zh
                                      ? i.clinicalSynopsis_zh
                                          .join(';')
                                          .replace(/\s+/g, '')
                                      : i.phenoClinicalFeaturesCNStr
                                      ? i.phenoClinicalFeaturesCNStr.join('\n')
                                      : t('No Results')
                                  }`

                                  const DescriptionHighlightedText =
                                    higlitghtStr
                                      ? phenoDescriptionCNText.replace(
                                          regex,

                                          (match: any) =>
                                            `<span style="color: red;">${match}</span>`
                                        )
                                      : phenoDescriptionCNText
                                  const ClinicalHighlightedText = higlitghtStr
                                    ? phenoClinicalCNText.replace(
                                        regex,

                                        (match: any) =>
                                          `<span style="color: red;">${match}</span>`
                                      )
                                    : phenoClinicalCNText

                                  return {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'span-blod',
                                            children: [
                                              {
                                                text: `${index + 1}、${
                                                  i.pheno_name_cn ?? '-'
                                                }(OMIM:${i.phenoMim});${
                                                  i.inheritance ?? '-'
                                                }`
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: DescriptionHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      },
                                      {
                                        type: 'HighlightText',
                                        children: [
                                          {
                                            text: ClinicalHighlightedText.replace(
                                              /\(.*?\)/g,
                                              ''
                                            )
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                })
                              : row.MitoMap && row.MitoMap.disease_ch
                              ? [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'paragraph',
                                        children: [
                                          {
                                            type: 'h3',
                                            text: `${
                                              row?.MitoMap?.disease_ch ?? '-'
                                            }`
                                          }
                                        ]
                                      },
                                      {
                                        type: 'paragraph',
                                        text: `${
                                          row?.MitoMap?.info ?? t('No Results')
                                        }`
                                      }
                                    ]
                                  }
                                ]
                              : [
                                  {
                                    text: ''
                                  }
                                ]
                        },
                        {
                          type: 'p7',
                          children: [
                            {
                              text: `该变异人群频率如下：`
                            }
                          ]
                        },
                        {
                          type: 'table-available',
                          children: [
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `数据库` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `GnomAD-EAS` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `1000g` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ExAC` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `ALFA` }]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              type: 'table-row',
                              children: [
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [{ text: `频率值` }]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_ALL}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${row.gnomAD_exome_EAS}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        {
                                          text: `${
                                            totalAftable
                                              ? totalAftable['1000g']
                                              : '.'
                                          }`
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ExAC ?? '.'}` }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  type: 'table-cell',
                                  children: [
                                    {
                                      type: 'p3-center',
                                      children: [
                                        { text: `${totalAftable?.ALFA ?? '.'}` }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: `以上结果请结合家系和临床进一步分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '建议'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `建议临床医生参考本检测报告，结合受检者临床症状和家系验证结果进行综合分析。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测方法和局限性'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `检测方法：`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本方法以受检者血液、唾液或其他组织来源的基因组 DNA 为检测材料，首先将 DNA 打断并制备文库，然后通过igenetechV5 芯片对目标基因外显子及临近剪切区的 DNA 进行捕获和富集，最后使用 MGISEQ-2000 或DNBSEQ-T7 测序平台进行变异检测。测序数据质控指标为：目标区域平均测序深度≥200×，其中目标区平均深度>20× 的位点所占比例>98.5%。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `数据分析：`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      测序片段通过 BWA 与 UCSC hg19 人类参考基因组进行比对，去除重复。使用 GATK 进行碱基质量值校正SNV、INDEL 和基因型检测。使用 ExomeDepth 进行外显子水平的拷贝数变异检测。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `变异筛选与解读：`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      基因命名按照人类基因组组织基因命名委员会（HGNC）命名规范；变异命名按照人类基因组变异学会（HGVS）命名规范。基于受检者临床信息、人群数据库、疾病数据库和生物信息预测工具进行变异注释和筛选（参考数据库及版本见附录）。变异致病性分类依据美国医学遗传学和基因组学学会（ACMG）和美国分子病理学会（AMP）序列变异解释指南（附录），并参考 ClinGen 序列变异解读工作组和英国临床基因组科学学会（ACGS）等对该指南细化解读。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `检测局限性：`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      鉴于当前医学检测技术水平的限制和受检者个体差异等原因，本检测无法保证100%的准确性以及100%的成功率。该方法适用于所送检基因的外显子区（不包括启动子区等非编码区）及外显子相邻20bp的内含子区中的点突变（检测准确率为99%以上）、小的缺失插入突变（20bp以内）（检测准确率为99%以上），以及外显子水平的缺失重复变异（包括SMN1基因7号外显子的缺失情况）（检测准确率为95%以上）（受相关基因组区域的结构、外显子大小、GC含量、是否存在重复区域和高度同源性区域及外显子区覆盖度的影响，本方法可能存在一定的假阴几率机率）。该方法可以额外检测ClinVar及HGMD数据库记录致病的内含子区变异。该技术方法可检测线粒体基因组上的点突变和20bp以内插入缺失变异，不能检测线粒体基因组拷贝数变化。对于线粒体变异，仅报告华大内部数据库收录的，且突变率≥10%的位点；在报告原则下限的变异，也会根据变异的重要性酌情报告。该方法可提示与受检者表型相关的其它变异类型，包括大片段的基因组拷贝数变异（例如缺失/重复区间≥1Mb）、染色体非整倍体、三倍体、杂合性缺失（LOH，区间≥5Mb）、以及8种动态突变致病变异，对于这部分结果，因其准确性相对较低，仅供临床参考。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本方法不能检测大片段的基因组拷贝数变异（缺失/重复区间<1Mb）和基因组结构变异（例如易位、倒位、<5Mb的LOH）。本方法不适于检测特殊类型变异（包括但不限于体细胞突变、不在全外芯片覆盖范围内的深度内含子变异、动态突变、基因甲基化、假基因区域变异、复杂重组等，上述情形均为不适用于高通量检测的技术局限性范畴）。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      由于部分基因存在高重复低复杂度区域或假基因，以致检测不能完全覆盖其所有外显子区，但总体覆盖度可达95%以上。受捕获效率影响，不同基因及外显子区段的覆盖度可能无法达到100%（低覆盖度区域列表链接http://db.bgidx.cn/）。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      由于探针捕获高通量测序技术受检测样本类型，检测样本质量的影响，存在数据不均衡而影响拷贝数变异的情况，实验室在两次提取建库测序依然存在数据不均衡的情况下，则只分析点突变和小的缺失插入突变（20bp以内）。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本次检测按照受检者主诉，对应OMIM数据库（2022Q4）中已明确的单基因遗传病致病基因进行分析，多基因易感疾病相关基因及复杂疾病相关基因不包含在此次分析范围内。若受检者选择分析指定基因集，则非指定基因不在本次分析范围。指定基因集的基因命名，需规范使用检测项目目录中的基因名。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      限于目前人类对疾病认识水平的局限性， 如未检出能完全解释受检者临床表型的特定基因及致病变异位点 (即阴性结果) ，并不能排除受检者存在某种遗传疾病的可能性，因为某些疾病的发病可能与其它未知基因或本方法难以检测到、或无法确定的基因变异类型有关。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本检测所用 DNA 源自受检者血液或其他体细胞样本，不能排除嵌合现象所致的解读偏差。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `检测声明：`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本报告仅限与受检者临床表型相关且与受检者家族遗传病史不冲突的致病/疑似致病/意义未明变异。实验室无法对医生或受检者提供的临床表型及临床怀疑疾病的真实性、准确性、全面性做出保证。由于临床表型和家族史提供不准确或不完善的样本，存在报告位点提报不精准的风险。特定变异的遗传性是基于向实验室描述的家庭关系，非母（源）性或非父（源）性的可能性未被排除。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      报告结论均为实验室检测数据，仅用于变异检测之目的，仅供临床医生参考，不代表最终诊断结果。本报告中所列变异未必都会导致受检者发病，是否致病需结合变异影响、遗传方式及临床特征等多因素综合分析。本报告中与疾病相关性、相关性说明、基因变异关联疾病及疾病临床特征等信息均来自现有已报道的研究结果，解读规则参考 ACMG 相关指南（附录），变异致病性的判定依据现有的临床表型、文献报道和数据库及生物信息学软件判定，受科学发展的阶段性限制，仅供参考。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      本报告无法排除在该受检者的基因组中存在本项目检测范围之外的其它致病性改变。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `      根据受检者签署知情同意书中有关意外发现（ secondary findings ）的情况 ，本报告将包含或不包含SecondaryFinding_Var(V1.1_2020.3)数据库中位点。`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `**本报告采纳 T/SZGIA 4—2018 团体标准。`
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `**本报告结果只对送检样品负责。本中心对以上检测结果保留最终解释权，如有疑义，请在收到结果后的 7 个工作日内与我们联系。`
                    }
                  ]
                },
                {
                  type: 'p7-color-bold',
                  children: [
                    {
                      text: `请到相关遗传咨询门诊或生殖医学门诊就诊！`
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: 'ACMG指南证据项说明'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1：当一个疾病的致病机制为功能丧失（LOF）时，检出变异为无功能变异（无义突变、移码突变、经典±1或2的剪接突变、起始密码子变异、单个或多个外显子缺失）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Strong：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Moderate：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PVS1_Supporting：PVS1 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS1：与先前已确定为致病性的变异有相同的氨基酸改变。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2：患者的新发变异, 且无家族史（经双亲验证）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Very Strong：PS2 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Moderate：PS2 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS2_Supporting：PS2 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS3：体内、体外功能实验已明确会导致基因功能受损的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4：变异出现在患病群体中的频率显著高于对照群体。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4_Moderate：PS4 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PS4_Supporting：PS4 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM1：位于热点突变区域，和/或位于已知无良性变异的关键功能域。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM2：ESP 数据库、千人数据库、EXAC 数据库中正常对照人群中未发现的变异（或隐性遗传病中极低频位点）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3：在隐性遗传病中，在反式位置上检测到致病变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Very Strong：PM3 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Strong：PM3 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM3_Supporting：PM3 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM4：非重复区框内插入/缺失或终止密码子丧失导致的蛋白质长度变化。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM5：新的错义突变导致氨基酸变化，此变异之前未曾报道，但是在同一位点，导致另外一种氨基酸的变异已经确认是致病性的。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6：未经父母样本验证的新发变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Very Strong：PM6 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Strong：PM6 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PM6_Supporting：PM6 降级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1：突变与疾病在家系中共分离（在家系多个患者中检测到此变异）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1_Strong：PP1 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP1_Moderate：PP1 升级情况。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP2：对某个基因来说，如果这个基因的错义变异是造成某种疾病的原因，并且这个基因中良性变异所占的比例很小，在这样的基因中所发现的新的错义变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP3：多种统计方法预测出该变异会对基因或基因产物造成有害的影响，包括保守性预测、进化预测、剪接位点影响等。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'PP4：变异携带者的表型或家族史高度符合某种单基因遗传疾病。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BA1：ESP 数据库、千人数据库、EXAC 数据库中等位基因频率>5%的变异（若无特异基因或变异的频率阈值矫正）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS1：等位基因频率大于疾病发病率。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS2：对于早期完全外显的疾病，在健康成年人中发现该变异（隐性遗传病发现纯合、显性遗传病发现杂合, 或者X 连锁半合子）。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS3：在体内外实验中确认对蛋白质功能和剪接没有影响的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BS4：在一个家系成员中缺乏共分离。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP1：已知一个疾病的致病原因是由于某基因的截短变异，在此基因中所发现的错义变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP2：在显性遗传病中又发现了另一条染色体上同一基因的一个已知致病变异，或者是任意遗传模式遗传病中又发现了同一条染色体上同一基因的一个已知致病变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP3：功能未知重复区域内的缺失/插入，同时没有导致基因编码框改变。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP4：多种统计方法预测出该变异会对基因或基因产物无影响，包括保守性预测、进化预测、剪接位点影响等。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP5：在已经有另一分子致病原因的病例中发现的变异。'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'BP7：同义变异且预测不影响剪接。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '致病性计算方法'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r8',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '致病的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Pathogenic)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥1个强(PS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥2个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+1个中等(PM)+1个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(PS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+≥3个中等(PM1)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+1个中等(PM)+≥4个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r6',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '可能致病的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Likely pathogenic)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个非常强(PVS)+1个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+1-2个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(PS)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥3个中等(PM)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `2个中等(PM)+≥2个支持(PP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '良性的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Benign)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(BS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个强(BS)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '可能良性的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(Likely benign)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `1个强(BS)+1个支持(BP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `≥2个支持(BP)`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-r2',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '意义不明确的'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(VUS)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `不满足上述标准或`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: `良性和致病标准相互矛盾`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: '注：各致病性等级对应序号间为“或”的关系'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '一、染色体数目异常及拷贝数变异（≥1M）'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-min-100',
                  children: [{ text: '1.检测结果' }]
                }
              ]
            },
            {
              type: 'table-cell-c5',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `${reportsVariants
                        .filter((row) => row.variant_type === 'CNV')
                        .map(
                          (row) =>
                            `46X${
                              samples &&
                              samples[0] &&
                              samples[0].gender === 'male'
                                ? 'X'
                                : 'Y'
                            },${row.SV_type.toLocaleLowerCase()}(${
                              chromosomeData && chromosomeData.length
                                ? chromosomeRegion(
                                    row.chrom,
                                    row.SV_start,
                                    row.SV_end,
                                    chromosomeData.filter(
                                      (item) => item['#chrom'] == row.chrom
                                    )
                                  )
                                : ''
                            }).seq[GRCh37/hg19](${row.SV_start}-${row.SV_end})`
                        )
                        .join(';')}`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c2',
              children: [
                {
                  type: 'p3-center-min-100',
                  children: [{ text: '2.结果说明' }]
                }
              ]
            },
            {
              type: 'table-cell-c5',
              children: [
                ...reportsVariants
                  .filter((row) => row.variant_type === 'CNV')
                  .map((row) => {
                    return {
                      type: 'p7',
                      children: [
                        {
                          type: 'p7',
                          children: [
                            {
                              text: `样本检出${row ? row.chrom : '**'}号染色体${
                                row ? `${row.SV_start}:${row.SV_end}` : '**'
                              }区域约${
                                row ? (row.LEN / 1024).toFixed(0) : '**'
                              }Kb的${
                                row && row.SV_type
                                  ? row.SV_type.toLocaleUpperCase() === 'DEL'
                                    ? 'DEL （缺失）'
                                    : 'DUP （重复）'
                                  : ''
                              }（拷贝数${
                                row ? row.CN : '**'
                              }），按照ACMG指南，该CNV的致病性评级为${
                                row ? row.ccnv_classification : '**'
                              }。涉及${
                                row
                                  ? (
                                      row.gene_info?.omim_disease_genes ||
                                      row.omim_genes
                                    )?.length
                                  : '**'
                              }个RefSeq蛋白编码基因。致病证据:${
                                row.AnnotSV_evidences
                              }(annotsv证据).`
                            }
                          ]
                        },
                        {
                          type: 'HighlightText',
                          children: [
                            {
                              text: `${
                                row.ScipCnvDescription &&
                                row.ScipCnvDescription.positiveInfo &&
                                row.ScipCnvDescription.positiveInfo &&
                                row.ScipCnvDescription.positiveInfo.length
                                  ? row.ScipCnvDescription.positiveInfo
                                      .map((i: any) =>
                                        i18n.language === 'zh' ? i.zh : i.en
                                      )
                                      .join(';')
                                  : ''
                              }`
                            }
                          ]
                        },

                        ...row.OMIMFlat.map((i: any) => {
                          return {
                            type: 'p7',
                            children: [
                              {
                                text: `${
                                  i?.pheno_name_cn
                                }是一种常染色体显性遗传（${
                                  i?.inheritance
                                }）疾病，患者常见临床表征有:${i.phenoDescriptionCN
                                  ?.map((item: any) => {
                                    const temp = item
                                      .filter(
                                        (i: any) =>
                                          i && i.text && i.text !== '.'
                                      )
                                      .map(
                                        (i: any) =>
                                          `${i.text}${
                                            i.value && i.value !== '.'
                                              ? `(${i.value})`
                                              : ''
                                          }`
                                      )
                                      .join()

                                    return temp
                                  })
                                  .join(',')
                                  .replace(/\s+/g, '')
                                  .replace(/\(.*?\)/g, '')
                                  .replace(/,+\)/g, '')
                                  .replace(/,综述+\)/g, '')}`
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }),
                {
                  type: 'p7',
                  children: [
                    {
                      text: reportsVariants
                        .filter((row) => row.variant_type === 'CNV')
                        .filter(
                          (row) =>
                            row.ccnv_classification.toLocaleLowerCase() ===
                              'pathogenic' ||
                            row.ccnv_classification.toLocaleLowerCase() ===
                              'likely pathogenic'
                        ).length
                        ? `     综上分析，该片段重复为致病变异。建议医生结合临床进行判断。`
                        : reportsVariants.filter(
                            (row) => row.variant_type === 'CNV'
                          ).length
                        ? `     综上分析，该片段重复为非致病变异。建议医生结合临床进行判断。`
                        : ''
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      type: 'span-blod',
                      children: [
                        {
                          text: `     基于高通量全外的CNV检测不属于全外的常规检测范围，不排除假阳性或者嵌合的可能。如需更精准的染色体CNV结果，建议送检相关染色体检测。`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: ``
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: `     参考基因 GRCh37/hg19 `
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '二、参考资料'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: `${reportsVariants
                        .filter((row) => row.variant_type === 'CNV')
                        .map((row) => {
                          if (row.OMIMArr) {
                            return row.OMIMArr.map((item: any) => item.omimData)
                              .flat()
                              .map((item: any) => `OMIM:${item.phenoMim}`)
                          } else if (row.newOMIMData) {
                            return row.newOMIMData.map(
                              (item: any) => `OMIM:${item.omim_id}`
                            )
                          }
                        })
                        .flat()
                        .join(';')}`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '三、检测局限性'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: '1. 正文部分只报告非整倍体、三倍体、≥1Mb的染色体拷贝数变异以及≥5Mb的杂合性缺失（LOH），由于技术局限性不排除有更小的染色体结构或基因片段异常的可能性。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '2. 本技术方法无法检测高度重复、高度固缩区域，高复杂度区域或假基因区域的变异；无法检出多倍体（三倍体除外）；无法检出动态突变、倒位、易位、等臂染色体、环状染色体、双着丝粒染色体、标记染色体等复杂结构性变异；无法保证低比例嵌合体、1Mb以下的染色体拷贝数变异（CNV）以及5Mb以下的杂合性缺失（LOH）的检出。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '3. 由于父母近亲结婚导致的子代LOH，不在本报告范围内。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '4. 本检测报告内容不体现性别，性染色体用XN代替，仅在性染色体检出异常时报告其异常信息。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '5. 鉴于当前医学检测技术水平的限制和个体差异等不同原因，即使在检测人员已经履行了工作职责和操作规程的前提下，仍无法保证100%的准确性。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '6. 在报告原则下限的变异，也会根据变异的重要性酌情报告。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '7. 以上结论均为实验室检测数据，仅用于突变检测之目的，供临床参考，不代表临床最终诊断结果。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '8. 本报告结果只对送检样本负责，本科室对以上检测结果保留最终解释权，如有疑义，请在收到结果后的7个工作日内与我们联系。'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p3-center',
      children: [{ text: `` }]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c9-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '目标区捕获高通量测序参数'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '样本编号' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '原始数据' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '产出' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区长度' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '（bp）' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区覆盖' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '度' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区平均' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '深度（X）' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区平均深' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '度>10X 位点所' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '占比例' }]
                }
              ]
            },
            {
              type: 'table-cell',
              children: [
                {
                  type: 'p3-center-bold',
                  children: [{ text: '目标区平均深' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '度>20X 位点所' }]
                },
                {
                  type: 'p3-center-bold',
                  children: [{ text: '占比例' }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          const fastQc = row.fastQc ?? {}
          const metricsData = fastQc.metricsData ?? {}
          const rawReads = metricsData.rawReads ?? '-'
          const readsMappedPercent = metricsData.readsMappedPercent ?? '-'
          const targetRegionLength = metricsData.targetRegionLength ?? '-'
          const pctData = (fastQc.barChartData ?? []) as any[]
          const x1 = pctData.find((i) => i.name === '1x')?.value
          const x10 = pctData.find((i) => i.name === '10x')?.value
          const x20 = pctData.find((i) => i.name === '20x')?.value

          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.name ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: row.sample?.fileSize
                          ? row.sample?.fileSize > 1000
                            ? `${(row.sample?.fileSize / 1024).toFixed(2)}G`
                            : `${row.sample?.fileSize}MB`
                          : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: targetRegionLength ? `${targetRegionLength}` : `-`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x1 ? `${x1}` : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.avgReadDepth ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x10 ? `${x10}` : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x20 ? `${x20}` : '-'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '检测结果相关附图'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: '无'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7-2',
              children: [
                {
                  type: 'header3-yunnan-krd2',
                  children: [
                    {
                      text: '受检者 OMIM 数据库中已知致病基因上低频变异信息'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c7',
              children: [
                {
                  type: 'p7',
                  children: [
                    {
                      text: '见附录'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '注：'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '本报告参考 hg19 人类基因组版本。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '限于篇幅，本表仅列出检测范围内，OMIM 中已知致病基因上的频率低于或等于 1%的变异（参考数据库包括：千人基因组，ExAC，ESP6500，GnomAD，BGI 本地数据库）。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '*杂合性: Hom 表示此变异位点为纯合变异，Het 表示此变异位点为杂合变异，Hemi 表示此变异位点为性染色体半合子变异。'
                    }
                  ]
                },
                {
                  type: 'p7',
                  children: [
                    {
                      text: '* “.”表示数据库没有记录'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
